<template>
	<page-container
		class="container"
		:page="page"
		:class="{ 'no-heading-image': !page.headingImage, 'no-video': !page.embedCode }"
	>
		<video-embed v-if="page.embedCode" :embedcode="page.embedCode" />

		<heading-image
			v-else-if="page.headingImage"
			:fullpage="true"
			:header="page.title || page.header"
			:heading-image="{
				image: page.headingImage,
				imageAlt: page.headingImageAlt,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitAlt: page.headingImagePortraitAlt,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content :title="(page.title || page.header) ?? 'Page not found'" :content="page.content">
			<div v-if="page.showGroupsForm" class="row form-row">
				<div class="columns column6 align-left">
					<h1 v-if="!page.headingImage">{{ page.title || page.header }}</h1>
					<wysiwyg-content :content="page.content" />
				</div>
				<div class="columns column6">
					<image-slider v-if="page.images?.length" :images="page.images" />
					<div class="form-wrapper">
						<wysiwyg-content :content="defaults[locale].website.groupsFormContent" />
						<button class="form-toggle" @click="expanded = !expanded">
							{{ defaults[locale].website.groupsFormButton }}
						</button>
						<slide-up-down v-model="expanded" :duration="400">
							<div class="content">
								<contact-form v-if="form" name="groups" :form="form" />
							</div>
						</slide-up-down>
					</div>
				</div>
			</div>
			<div v-else class="row">
				<div class="columns column12 align-left">
					<h1 v-if="!page.headingImage">{{ page.title || page.header }}</h1>
					<wysiwyg-content :content="page.content" />
					<div class="columns column6" style="float: right; margin-top: 25px">
						<image-slider v-if="page.images?.length" :images="page.images" />
					</div>
				</div>
			</div>
		</main-content>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>

		<footer-image
			v-if="page.footerImage?.length"
			:image="{
				image: page.footerImage,
				imageWebp: page.footerImageWebp,
				imageAlt: page.footerImageAlt,
			}"
		/>
	</page-container>
</template>

<script setup lang="ts">
const { page, fetchPage } = usePage();
const { locale } = useI18n();
const { defaults, fetchDefaults } = useDefaults();

await fetchPage();
await fetchDefaults();

const expanded = ref(false);

const { data: form } = await useWebsiteFetch<FormField[]>('groups', {
	query: { language: locale.value },
	key: `${locale.value}/groups`,
});

useHead({
	bodyAttrs: {
		class: 'subpage',
	},
});
</script>

<style lang="scss" scoped>
.form-toggle {
	outline: none;
	border: none;
	color: var(--primary-background-color);
	background: #fff;
	text-transform: uppercase;
	font-family: var(--heading-font-family);
	padding: 3px 9px 5px;
	cursor: pointer;
	font-size: 16px;
	letter-spacing: 2px;
	margin: 0 0 25px;
	transition: all 0.3s ease-in-out;

	&:hover {
		background: #fdf0f4;
	}
}

.form-row {
	.columns {
		padding: 0 25px;
	}
}
</style>
